import { Typography } from '@material-ui/core'

import { Brand } from '../components/Brand'

interface Props {
  header?: string
  headerCaption?: string
  headerImageSrc?: string
  headerImageAlt?: string
  headerImageLink?: string
}

export function Header({
  header,
  headerCaption,
  headerImageSrc,
  headerImageAlt,
  headerImageLink,
}: Props) {
  return header ? (
    <header dangerouslySetInnerHTML={{ __html: header }} />
  ) : (
    <header>
      <div className="faq-layout-header">
        <h1 className="faq-logo">
          <Brand src={headerImageSrc} alt={headerImageAlt} link={headerImageLink} />
        </h1>
        <div className="faq-header-spacer" />
        {headerCaption && (
          <Typography paragraph className="faq-header-caption" variant="caption">
            {headerCaption}
          </Typography>
        )}
      </div>
    </header>
  )
}
